import TableTemplate from "../../TableTemplate/tableTemplate";
import { IAdjustmentTablesSearchParam } from "../../../Interfaces/deltaHedgeAdjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import { getDeltaGammaRefTable } from "../../../Requests/optionDomain";

interface IProps {
  searchParams: IAdjustmentTablesSearchParam;
}

const DeltaGammaRefTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAdjustmentTablesSearchParam, any>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[400px] !w-full overflow-x-auto"
        />
      )}
      tableWrapperClassname="!w-full"
      getDataTable={getDeltaGammaRefTable}
      searchParameters={searchParams}
      withSort
    />
  );
};

export default DeltaGammaRefTable;
